// NavBarItems.jsx
export const NavBarItems = [
  {
    key: "home",
    url: "/",
    cName: "nav-links",
  },
  {
    key: "menu",
    url: "/meni",
    cName: "nav-links",
  },
  {
    key: "toplar",
    url: "/",
    cName: "nav-links nav-toplar",
  },
  {
    key: "about",
    url: "/onas",
    cName: "nav-links",
  },
  {
    key: "gallery",
    url: "/galerija",
    cName: "nav-links",
  },
  {
    key: "park",
    url: "/loka",
    cName: "nav-links nav-loka",
  },
];
